// Menu list for the title screen and the system menu: big display-type rows with a diamond that
// slides in on hover/focus; rows stagger in.
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { stagger } from './Motion';

export function MenuList({ children, className = '', label }: { children: ReactNode; className?: string; label: string }) {
  return <ul className={`fk-menu ${className}`} role="menu" aria-label={label}>{children}</ul>;
}

export function MenuItem({ index = 0, primary, hint, icon, className = '', children, ...rest }: ButtonHTMLAttributes<HTMLButtonElement> & { index?: number; primary?: boolean; hint?: ReactNode; icon?: ReactNode }) {
  return (
    <li role="none">
      <button type="button" role="menuitem" className={`fk-menu__item ${primary ? 'fk-menu__item--primary' : ''} ${className}`} style={stagger(index)} {...rest}>
        {icon && <span aria-hidden="true">{icon}</span>}
        <span>{children}</span>
        {hint && <span className="fk-menu__hint">{hint}</span>}
      </button>
    </li>
  );
}
